import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/bulkRemove`;

export const ROUTE: RouteDefinition = `${baseRoute}/bulkRemove`;

export const URL = (): RouteDefinition => `${baseRoute}/bulkRemove`;
